import React, {Component} from 'react';
import { adminloadTP, reviseTUser, AuthenticatedUser, putToast, stopTimer } from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'
import Modal from 'react-responsive-modal';
import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';
import moment from 'moment';
import AvatarDisplay from "../../../common/avatarDisplay"

class TournamentAdminUserActivity extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            selectedTUser: "",
            selectedUserId: '',
            tData: {},
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('dashboard', 'none', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                   
                    this.setState({tData: d2.tournamentPage, tUsers: d2.tUsers, loading: false});                    

                }
            });
        } else this.setState({ loading: false});
    };


    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row) {
            if (column.id === 'avatar') {
                return {
                    onClick: () => { 
                        this.props.history.push(`/pages/dashboard?uid=${rowInfo.original.userId}`)
                    }                                      
                }
            } else {
                return {
                    onClick: () => { 
                        this.setState({
                            selectedUserId: rowInfo.original.userId, 
                            selectedTUser: rowInfo.original,
                            open: true})
                    },
                    
                    onMouseOver: (e) => {
                        this.setState({
                            selected: rowInfo.index
                        })
                    },
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                    
                }
            }
        } else { return {} }
    }
      
          
    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    onTUserJsonChanged = (event) => {
        this.setState({ selectedTUser: event.json });
    }

    onCloseModal(mode) {
        this.setState({ selectedUserId: null, selectedTUser: '', open: false });
        if (mode === true && this.state.selectedUserId && this.state.selectedTUser) {


            reviseTUser(JSON.parse(this.state.selectedTUser)).then(d2 => {
                if (!d2 || d2.error) {
                    console.log(d2 ? d2.error : "Error - no data");
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    putToast.success(d2.message);
                    this.setState( {open: false }); 
                }
            }); 
        }
    }
    convertImage(buffer, mime) {        
        let TYPED_ARRAY = new Uint8Array(buffer.data);
        const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);
        let base64String = btoa(STRING_CHAR);
        const imageUrl = `data:${mime};base64,` + base64String.toString('base64');

        return imageUrl; 
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, open, user, tUsers } = this.state;
            const data = tUsers;
            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Competitor List - ${user.displayname}`} title3=""
                bcTitle="Activity List" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`},
                    {name: "Dashboard", url: `/tournament/admin/dashboard/${tData._id}`}
                ]}
            >              
                <div className="container-fluid">                           
                    <div className="row">
                        <div className="col-sm-12">
                            <ReactTable
                                filterable
                                defaultFilterMethod={ (filter, row, column) => {
                                    const id = filter.pivotId || filter.id
                                    if (column.id !== 'avatar' && column.id !== 'category') {
                                        return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                    }
                                    else return true;
                                }}
                                data={data}
                                columns={[{
                                    id: 'avatar',
                                    Header: 'Avatar',
                                    accessor: 'avatar',
                                    maxWidth: 60,
                                    Cell: row => <AvatarDisplay  size={40}/>
                                },{
                                    Header: 'TUser',
                                    accessor: 'displayname',
                                },{
                                    id: 'category',
                                    Header: 'Type',
                                    accessor: 'isJudge',
                                    Cell: (row) => (
                                        <span>{`${row.original.isJudge ? "Judge" : row.original.isCompetitor ? "Competitor" : "Guest"}`}</span>
                                    )
                                },{
                                    Header: 'Status',
                                    accessor: 'status'
                                },{
                                    Header: 'Email',
                                    accessor: 'email',
                                },{
                                    Header: 'Phone',
                                    accessor: 'phone',
                                },{
                                    Header: 'Last Activity',
                                    accessor: 'lastActivityDate',
                                    Cell:  (props) => {                                            
                                        return (
                                           <span >{props.value ? moment(props.value).format('LLL') : "never"}</span>
                                    )},                                
                                }]}                                        
                                pageSize={(data.length > 20) ? 20 : data.length}
                                showPagination={(data.length > 20)}                    
                                defaultPageSize={20}    
                                getTdProps={this.getTdProps}                                                                                                                                                                                                        
                            />
                        </div>
                    </div>  
                </div>
                <Modal open={open} onClose={this.onCloseModal} >
                    <div className="modal-header">
                        <h5 className="modal-title f-w-600" id="exampleModalLabel2">Edit Tournament User</h5>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-10">  
                                <JSONInput
                                    id          = 'a_unique_id'
                                    locale      = { locale }
                                    height      = '550px'
                                    width       = '550px'
                                    placeholder = { this.state.selectedTUser ? this.state.selectedTUser  : [  { name: 'Home', link: '/' } ] }
                                    onChange = {this.onTUserJsonChanged}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>Save</button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                    </div>
                </Modal>
                          
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminUserActivity;